import { useStore } from '@psl/flows/showcase/functions/useCurrentShow/useCurrentShow';
import { currentUserId } from '@psl/functions/auth/utils';
import { usePersistFn } from '@psl/functions/hooks/usePersistFn';
import { AnalyticEvents } from '@psl/generated/AnalyticEvents';
import { lazy, useEffect } from 'react';
import { adaptiveWrapperOptions } from '../../../appComponents/ModalWrapper';
import { screenOptionsForLightMode } from '../../../functions/navigation/screenOptions';
import { wrapLazyNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';
import type { CreateCommentChatFlowProps } from './CreateCommentChatFlowContent';

const CreateCommentChatFlowContent = lazy(
  () => import('./CreateCommentChatFlowContent'),
);

const CreateCommentChatFlow = wrapLazyNavigatorScreen(
  (props?: CreateCommentChatFlowProps) => {
    const store = useStore(currentUserId());

    const trackStartEvent = usePersistFn(() => {
      AnalyticEvents.default.commentchatStart({
        sellerId: store?.id ?? '',
        sellerName: store?.name ?? '',
      });
    });

    useEffect(() => {
      trackStartEvent();
    }, [trackStartEvent]);

    return <CreateCommentChatFlowContent {...props} />;
  },
  adaptiveWrapperOptions(isMobile =>
    isMobile
      ? screenOptionsForLightMode({
          presentation: 'card',
        })
      : screenOptionsForLightMode({
          presentation: 'transparentModal',
          cardOverlayEnabled: true,
          cardStyle: { backgroundColor: 'transparent' },
          animationEnabled: false,
          headerShown: false,
        }),
  ),
);

export default CreateCommentChatFlow;
